import { ModuleManagerService } from '../services/module-manager.service';
import { ExtendService } from '../services/extend.service';
var moduleManager = new ModuleManagerService();
export function Components(config) {
    config.register.map(function (component) {
        /* tslint:disable */
        new ExtendService(moduleManager, "modules." + component.name, component);
    });
    return function (target) {
        moduleManager.init();
    };
}



//////////////////
// WEBPACK FOOTER
// ./decorators/components.ts
// module id = 32
// module chunks = 0